import React from 'react'
import styled from 'styled-components'

const ClearfixStyled = styled.div`
  display: block;
  height: ${props => props.height}px;
`

const Clearfix = ({ height = 16, ...props }) => {
  return (
    <ClearfixStyled height={height} {...props} />
  )
}

export default Clearfix
